export const FIREBASE_USER_TO_USER = {
  email: 'email',
  given_name: 'firstName',
  family_name: 'lastName',
  firebaseId: 'firebaseId',
  isNewUser: 'isNewUser',
};

export const mapObjectPartialy = (
  object: Record<string, unknown>,
  mapper: Record<string, string>,
) => {
  const newObject: Record<string, unknown> = {};
  Object.keys(mapper).forEach((key) => {
    newObject[mapper[key]] = object[key];
  });
  return newObject;
};

export const mapObject = (
  object: Record<string, unknown>,
  mapper: Record<string, string>,
) => {
  const newObject: Record<string, unknown> = {};
  Object.keys(object).forEach((key) => {
    newObject[mapper[key] || key] = object[key];
  });
  return newObject;
};
